export const SCANNER_ERROR_SOUND = require('./beep.mp3')
export const SCANNER_SUCCESS_SOUND = require('./success.mp3')